export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8211.79641476.jpg";